import logo from "../assets/images/diwali/desktop/2026/optimized/logo.webp";
import home from "../assets/images/diwali/mobile/optimized/home.webp";
import homeActive from "../assets/images/diwali/mobile/optimized/home-active.webp";
import liveChat from "../assets/images/diwali/mobile/optimized/livechat.webp";
import liveChatActive from "../assets/images/diwali/mobile/optimized/livechat-active.webp";
import me from "../assets/images/diwali/mobile/optimized/me.webp";
import meActive from "../assets/images/diwali/mobile/optimized/me-active.webp";
import promos from "../assets/images/diwali/mobile/optimized/promos.webp";
import promosActive from "../assets/images/diwali/mobile/optimized/promos-active.webp";
import sponsor from "../assets/images/diwali/mobile/optimized/sponsor.webp";
import sponsorActive from "../assets/images/diwali/mobile/optimized/sponsor-active.webp";

export const diwaliAssets = {
  logo,
  home,
  homeActive,
  liveChat,
  liveChatActive,
  me,
  meActive,
  promos,
  promosActive,
  sponsor,
  sponsorActive,
};
